var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('pt-select', _vm._g(_vm._b({}, 'pt-select', _vm.$props, false), _vm.$listeners), _vm._l(_vm.options, function (group) {
    return _c('pt-option-group', _vm._b({ key: group.label, attrs: { "label": group.label } }, 'pt-option-group', group, false), _vm._l(group.options, function (option) {
      return _c('pt-option', _vm._b({ key: option.value }, 'pt-option', option, false));
    }), 1);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };